import script from "./OrderConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./OrderConfirmation.vue?vue&type=style&index=0&id=2aac39be&lang=css"

const __exports__ = script;

export default __exports__